module.exports = __webpack_public_path__ + "static/media/avatar-23.9ca2dcb3.png";